"use client"

const ConfirmationModal = ({
  showConfirmation,
  orderDetails,           // ← New: pass all details in one object
  onConfirm,              // ← Standard name
  onCancel,               // ← Standard name
}) => {
  if (!showConfirmation) return null

  return (
    <div className="product-modal-overlay">
      <div className="confirmation-modal">
        <h4 className="fw-bold">Please review your details before submitting</h4>
        <p><strong>Brand:</strong> {orderDetails.brand}</p>
        <p><strong>Grade:</strong> {orderDetails.grade}</p>
        <p>
          <strong>Site Address:</strong> {orderDetails.siteAddress?.address}, {orderDetails.siteAddress?.state}
          {orderDetails.siteAddress?.pincode && `, ${orderDetails.siteAddress?.pincode}`}
        </p>

        {orderDetails.quantity && (
          <p><strong>Quantity:</strong> {orderDetails.quantity} bags</p>
        )}

        {orderDetails.mt && (
          <p><strong>MT:</strong> {orderDetails.mt}</p>
        )}

        {orderDetails.currentRate && (
          <p><strong>Rate:</strong> ₹{orderDetails.currentRate} per bag</p>
        )}

        <p>
          <strong>Payment Amount:</strong>{" "}
          {orderDetails.paymentAmount === "0.00" && orderDetails.selectedSiteBalance > 0
            ? "₹0.00 (Using existing balance)"
            : `₹${Number(orderDetails.paymentAmount).toLocaleString("en-IN")}`}
        </p>

        {orderDetails.paymentMethod === "utr" && orderDetails.utrNumber && (
          <p><strong>UTR Number:</strong> {orderDetails.utrNumber}</p>
        )}

        {orderDetails.selectedSiteBalance > 0 && (
          <div className="balance-info">
            <p><strong>Available Balance:</strong> ₹{orderDetails.selectedSiteBalance.toLocaleString("en-IN")}</p>
          </div>
        )}

        <div className="product-modal-buttons">
          <button onClick={onConfirm} className="confirm-btn">
            Yes, Place Order
          </button>
          <button onClick={onCancel} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal